const isFAQPage = window.pageData?.page === 'frequently-asked-questions' || window.pageData?.page?.includes('faq-');

function updateFaqLinks() {
  const deployedCountries = window.pageData?.R4_DEPLOYED_COUNTRIES || [];
  const {country: countryCode, lang: langCode} = getCountryAndLanguage();
  const isApp = isInAppWebView();
  const isR4 = deployedCountries.includes(countryCode.toUpperCase());
  const platform = isApp ? isR4 ? 'R4-App' : 'R3-App' : isR4 ? 'R4-Web' : 'R3-Web';

  const rules = [
    {
      match: '/send-money/start',
      params: { Route: 'SEND_MONEY', RouteType: 'REDIRECT', requestFrom: platform}
    },
    {
      match: '/pickupcashair',
      params: { Route: 'PICKUP_CASH', RouteType: 'REDIRECT', requestFrom: platform}
    },
    {
      match: '/track-transfer',
      params: { Route: 'TAT', RouteType: 'REDIRECT', requestFrom: platform}
    },
    {
      match: '/billpay-start',
      params: { Route: 'PAY_BILLS', RouteType: 'REDIRECT', requestFrom: platform}
    },
    {
      match: '/find-locations',
      params: { Route: 'FIND_LOCATION', RouteType: 'REDIRECT', requestFrom: platform}
    },
    {
      match: '/profile',
      params: { Route: 'PROFILE', RouteType: 'REDIRECT', requestFrom: platform}
    },
    {
      match: '/history',
      params: { Route: 'TXN_HISTORY', RouteType: 'REDIRECT', requestFrom: platform}
    },
    {
      match: '/refer-a-friend',
      params: { Route: 'REFER_FRIEND', RouteType: 'REDIRECT', requestFrom: platform}
    },
    {
      match: '/prepaid',
      params: { Route: 'WU_PREPAID', RouteType: 'REDIRECT', requestFrom: platform}
    },
    {
      match: '/my-receivers',
      params: { Route: 'MY_RECEIVERS', RouteType: 'REDIRECT', requestFrom: platform}
    },
    {
      match: '/sendinmatestart',
      params: { Route: 'SM_INMATE', RouteType: 'REDIRECT', requestFrom: platform}
    },
    {
      match: '/ding-topup',
      params: { Route: 'MOBILE_TOPUP', RouteType: 'REDIRECT', requestFrom: platform}
    },
    {
      match: '/redirect-start',
      params: { Route: 'UDM', RouteType: 'REDIRECT', requestFrom: platform}
    },
    {
      match: '/price-estimator',
      params: { Route: 'EST_PRICE', RouteType: 'REDIRECT', requestFrom: platform}
    },
    {
      match: '/settings',
      params: { Route: 'SETTINGS', RouteType: 'REDIRECT', requestFrom: platform}
    },
    {
      match: '/register',
      params: { Route: 'REGISTER', RouteType: 'REDIRECT', requestFrom: platform}
    },
    {
      match: '/login',
      params: { Route: 'LOGIN', RouteType: 'REDIRECT', requestFrom: platform}
    }
  ];

  const links = document.querySelectorAll('a[href]');
  replaceLinkQueryParams(links, rules);
}

if (isFAQPage && isMobileOrInApp()) {
  updateFaqLinks();
}
